module.exports = __webpack_public_path__ + "static/media/employee.a0be9147.png";